// Display upper bound for quantity dropdowns when max_qty_per_product is 0 (unlimited).
// Not a system maximum — see widget.md §Quantity Controls (dropdown bound is display-only).
export const QUANTITY_LIMIT = 20

// Per-product quantity ceiling for shopping mode: the configured cap, or the display fallback when unlimited.
// Findability is a single pick, so no per-product cap applies (mirrors ECommerceView `maxQty`).
export const qtyCap = (maxQtyPerProduct: number, findability: boolean): number =>
  !findability && maxQtyPerProduct > 0 ? maxQtyPerProduct : QUANTITY_LIMIT

// Promo/chrome strings hardcode US-dollar amounts (e.g. "$25", "$49") in every locale dict. Rewrite each
// "$NN" with the survey's currency symbol + position taken from the price mask, keeping the fixed promo
// number (these are marketing figures, not converted amounts). No mask → leave the text untouched.
export const localizeCurrency = (text: string, priceMask: string): string =>
  priceMask ? text.replace(/\$(\d+)/g, (_, amount) => priceMask.replace('{{price}}', amount)) : text
